import tw from 'tailwind-styled-components'

export const ModalCall = tw.div`px-8 border-2 border-primary rounded-lg  w-[545px] h-96 bg-white`

export const ButtonCancel = tw.div`
  justify-self-center
  self-center
`
